<template>
  <main class="main" :class="{ notMobile: !$store.state.mobileDevice, beforePreview: desktopBeforePreview }">
    <button @click="backStep" class="button button-back"><span>Back</span></button>
    <button class="button button-down" v-scroll-to="'#scrollto'"></button>

    <div class="frameme" id="frameme">
      <div id="imageframe" class="image-frame" :style="'background-image: url('+image+')'" ref="printMe">
        <img id="torotate" ref="resizedImage" :src="grillImage" v-if="$store.state.mobileDevice">

        <VueDragResize
          v-else
          :isActive="true"
          v-on:resizing="resize"
          v-on:dragging="resize"
          :style="'background-image: url('+grillImage+')'">
        </VueDragResize>
      </div>
    </div>

    <p class="note" id="scrollto">Pick a grill to match your mood</p>

    <div class="carousel-wrapper">
      <flickity ref="flickity" :options="flickityOptions" class="carousel" v-if="grills">
        <article v-for="grill of grills" :key="grill.id" @click="changeGrill(grill.id)" :class="{ active: grillID === grill.id }">
          <img :src="grill.image" ref="grill">
        </article>
      </flickity>
    </div>

    <div class="change-wrapper">
      <p>Swap Grill Colour</p> <button class="button" @click="grillColour"><img src="@/assets/swap.svg"></button>
      <button class="button submit" @click="preview2">PREVIEW PHOTO</button>
    </div>
    <!-- OUTPUT
    <img :src="finalImage"> -->

  </main>
</template>

<script>
import Flickity from 'vue-flickity'
import VueDragResize from 'vue-drag-resize'
import htmlToImage from 'html-to-image'

export default {
  name: 'grill',
  components: {Flickity, VueDragResize, htmlToImage},
  data () {
    return {
      width: 200,
      height: 100,
      top: 100,
      left: 100,
      desktopBeforePreview: null,
      image: this.$store.state.payload.image,
      finalImage: null,
      grillImage: '../img/grills/w-grill1.svg',
      grillID: 0,
      flickityOptions: {
        initialIndex: 2,
        prevNextButtons: true,
        pageDots: false,
        wrapAround: false
      },
      grills: [
        {
          id: 0, image: '../img/grills/w-grill1.svg', imageAlt: '../img/grills/grill14.svg', mood: 'original'
        },
        {
          id: 1, image: '../img/grills/w-grill2.svg', imageAlt: '../img/grills/grill15.svg', mood: 'sad'
        },
        {
          id: 2, image: '../img/grills/w-grill3.svg', imageAlt: '../img/grills/grill16.svg', mood: 'happy'
        },
        {
          id: 3, image: '../img/grills/w-grill4.svg', imageAlt: '../img/grills/grill17.svg', mood: 'angry'
        },
        {
          id: 4, image: '../img/grills/w-grill5.svg', imageAlt: '../img/grills/grill18.svg', mood: 'flirty'
        },
        {
          id: 5, image: '../img/grills/w-grill6.svg', imageAlt: '../img/grills/grill19.svg', mood: 'love-struck'
        },
        {
          id: 6, image: '../img/grills/w-grill7.svg', imageAlt: '../img/grills/grill20.svg', mood: 'original'
        },
        {
          id: 7, image: '../img/grills/w-grill8.svg', imageAlt: '../img/grills/grill21.svg', mood: 'sad'
        },
        {
          id: 8, image: '../img/grills/w-grill9.svg', imageAlt: '../img/grills/grill22.svg', mood: 'happy'
        },
        {
          id: 9, image: '../img/grills/w-grill10.svg', imageAlt: '../img/grills/grill23.svg', mood: 'angry'
        },
        {
          id: 10, image: '../img/grills/w-grill11.svg', imageAlt: '../img/grills/grill24.svg', mood: 'flirty'
        },
        {
          id: 11, image: '../img/grills/w-grill12.svg', imageAlt: '../img/grills/grill25.svg', mood: 'love-struck'
        },
        {
          id: 12, image: '../img/grills/grill13.svg', imageAlt: '../img/grills/grill13.svg', mood: 'rainbow'
        }
      ]
    }
  },
  mounted () {
    this.$store.state.isLoading = false
    this.changeGrill(0)

    if (this.$store.state.mobileDevice === true) {
      let zoom = require('zoom-it')
      let wnd = window
      let elem = document.getElementById('torotate')
      // eslint-disable-next-line
      let zm = new zoom.Zoom(elem, {
        pan: true,
        rotate: true
      }, wnd)
    }
    //
    // only doing code below in mounted because 'htmlToImage' only works on second capture for some reason?
    let that = this
    let node = document.getElementById('imageframe')
    htmlToImage.toJpeg(node, { quality: 0.5 })
      .then(function (dataUrl) {
        that.$store.commit('updateFinalImage', dataUrl)
        that.finalImage = dataUrl
      })
    // end workaround
  },
  methods: {
    backStep () {
      this.$store.commit('updatePayload', null)
      this.$router.push({ path: '/home' })
    },
    changeGrill (id) {
      this.grillID = id
      let grillObj = this.grills.find(obj => obj.id === id)
      this.grillImage = grillObj.image
      this.$store.commit('updateMood', grillObj.mood)
    },
    grillColour () {
      let grillObj = this.grills.find(obj => obj.id === this.grillID)
      if (this.grillImage === grillObj.image) {
        console.log('here')
        this.grillImage = grillObj.imageAlt
      } else {
        this.grillImage = grillObj.image
      }
    },
    resize (newRect) {
      this.width = newRect.width
      this.height = newRect.height
      this.top = newRect.top
      this.left = newRect.left
    },
    preview2 () {
      // this.$store.state.isLoading = true
      let that = this
      // let node = document.getElementById('imageframe')
      let node = document.getElementById('frameme')
      //
      // if desktop..
      if (!this.$store.state.mobileDevice) {
        that.desktopBeforePreview = true
      }
      //
      setTimeout(() => {
        htmlToImage.toJpeg(node, { quality: 0.5 })
          .then(function (dataUrl) {
            console.log(dataUrl)
            that.$store.commit('updateFinalImage', dataUrl)
            that.$router.push({ path: 'submit' })
          })
          .catch(function (error) {
            console.error('oops, something went wrong!', error)
          })
      }, 300)
    }
  }
}
</script>

<style scoped lang="scss">
@import "../scss/variables.scss";
  .main {
    position: relative;
    max-width: 500px;
    margin: 0 auto 40px;
    // margin: auto;
    text-align: center;

    &.notMobile {
      .image-frame {
        img {
          max-width: 150px;
        }
      }
    }
  }

  .frameme {
    overflow: hidden;
  }

  .image-frame {
    position: relative;
    width: 100%;
    max-width: 500px;
    height: auto;
    margin: auto;
    background-size: cover;
    background-repeat: no-repeat;
    overflow:hidden;

    &:before {
      content: '';
      display: block;
      width: 100%;
      height: 0;
      padding-bottom: 100%;
    }

    img {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      // max-width: 200px;
      margin: auto;
    }
  }

  #canvas {
    width: 100% !important;
    height: auto;
    background-size: cover;
    background-repeat: no-repeat;
    overflow:hidden;
  }

  p.note {
    margin: 0;
    font-weight: 600;
    line-height: 46px;
    color: $color-1;
  }

  .change-wrapper {
    display: inline-block;
    width: 100%;
    padding: 0 6%;

    p {
      display: inline-block;
      font-weight: 600;
      line-height: 46px;
      color: white;
    }

    .button {
      width: auto;
      margin: 0 0 0 10px;

      img {
        width: 15px;
      }
    }
    .button.submit {
      width: 100%;
      margin: 0 0 10px;
    }
  }

  .carousel-wrapper {
    display: inline-block;
    width: 100%;
    max-width: 600px;
    margin: auto;
  }

  article {
    width: 90px;
    margin: 0 5px;
    padding: 0 3px;

    &.active {
      border: 2px solid $color-1;
      border-radius: 2px;
    }
  }

</style>
